import { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface MotionItemProps {
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  value?: string | number | ReactNode;
  badge?: ReactNode;
  group: string;
  className?: string;
  titleClassName?: string;
  onClick?: () => void;
}

export const MotionItem = ({
  icon,
  title,
  subtitle,
  value,
  badge,
  group,
  className = '',
  titleClassName = '',
  onClick
}: MotionItemProps) => {
  return (
    <motion.div
      key={`${group}-${title}-${subtitle}-${value}`}
      className={`flex items-center justify-between ${className}`}
      whileTap={{ scale: 0.98 }}
      onClick={onClick}
    >
      <div className="flex items-center">
        {icon && <div
          className="flex items-center justify-center min-w-12 min-h-12 rounded-full bg-zinc-100 mr-5">
          {icon}
        </div>
        }
        <div className='flex flex-col gap-1'>
          <h3 className={`font-medium text-base text-black ${titleClassName}`}>{title}</h3>
          {subtitle && <p className="text-sm text-zinc-700 line-clamp-2">{subtitle}</p>}
          {badge}
        </div>
      </div>
      {value && <span className="font-medium text-base text-black ml-3">{value}</span>}
    </motion.div>
  );
};

export default MotionItem;